// extracted by mini-css-extract-plugin
export default {"sectionIcon":"SidebarSections-module__sectionIcon--EGPAx"};